import ProgramsForm from "../../ProgramsForm";

const CUSTOM_DEFAULT_VALUES = {
  rules: [
    {
      scope: {
        operator: "after",
        values: { days: "7" },
      },
      condition: "all",
      conditions: [
        {
          option: JSON.stringify([">", "${units}"]),
          values: [10],
        },
      ],
      actions: [
        {
          function: "INCREASE_PRICE",
          operator: "adjust_fixed",
          values: [10],
        },
      ],
    },
  ],
};

export { CUSTOM_DEFAULT_VALUES, ProgramsForm };
